export default __webpack_public_path__ + "0be8230bd648b72fc0f2f0dc6b77b6d9.woff2";